// react-bootstrap imports
import Stack from "react-bootstrap/Stack"
import Container from "react-bootstrap/Container"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"

import { Link, useNavigate } from "react-router-dom"
import Dropdown from "react-bootstrap/Dropdown"
import { userLogado } from "services/LoginFunctions"
import { userHasAccess } from "services/LoginFunctions"
import * as Links from "constants/links"

// assets imports
import headerHome from "assets/header_home.png"
import imageMinhaConta from "assets/header_minhaconta.png"
import headerAcessColors from "assets/header_acess_colors.png"
import logoPrefeitura from "assets/Logo_prefeitura.PNG"

import { ROLE } from "constants/userRoles"

function Image({ src, onClick })
{
    return (<img src={src} onClick={onClick} className="mx-1" width="20px" height="20px" alt="ícone"/>)
}

function SwitchColors()
{

    var r = document.querySelector(':root')
    var rs = getComputedStyle(r)
    if (rs.getPropertyValue('--bs-primary') === '#fff')  // switch back to default color style
    {
        r.style.setProperty('--bs-primary', '#0d6efd')
        r.style.setProperty('--btn-color', '#fff')
        r.style.setProperty('--bs-light-rgb', 'rgb(248,249,250)')
    }
    else    // switch to acessible color style
    {
        const buttons = document.getElementsByTagName("button")
        for (let i = 0; i <= buttons.length - 1; i += 1)
        {
            buttons[i].classList.toggle('btn-primary')
            buttons[i].classList.toggle('btn-dark')
        }

        const links = document.getElementsByTagName("a")
        for (let i = 0; i <= links.length - 1; i += 1)
        {
            links[i].classList.toggle('btn-primary')
            links[i].classList.toggle('btn-dark')
        }

        const elementsBgLight = document.getElementsByClassName("bg-light")
        for (let i = 0; i <= elementsBgLight.length - 1; i += 1)
        {
            elementsBgLight[i].classList.toggle('bg-white')
        }

        //r.style.setProperty('--bs-primary', '#fff')
        //r.style.setProperty('--btn-color', '#000')
        //r.style.setProperty('--bs-light-rgb', 'black')
    }
    
}

function ShortenFont()
{
    var r = document.querySelector(':root')
    var rs = getComputedStyle(r)
    if (rs.getPropertyValue('--tx-fs1') === 'calc(1.375rem + 1.5vw)')
    {
        r.style.setProperty('--tx-fs1', 'calc(1.325rem + 0.9vw)')
        r.style.setProperty('--tx-fs2', 'calc(1.3rem + 0.6vw)')
        r.style.setProperty('--tx-fs3', 'calc(1.275rem + 0.3vw)')
        r.style.setProperty('--tx-fs4', '1.25rem')
        r.style.setProperty('--tx-fs5', '1rem')
        r.style.setProperty('--tx-fs6', '0.8rem')
        r.style.setProperty('--tx-fs7', '0.6rem')
    }
}

function DefaultFont()
{
    var r = document.querySelector(':root')
    // var rs = getComputedStyle(r)
    r.style.setProperty('--tx-fs1', 'calc(1.375rem + 1.5vw)')
    r.style.setProperty('--tx-fs2', 'calc(1.325rem + 0.9vw)')
    r.style.setProperty('--tx-fs3', 'calc(1.3rem + 0.6vw)')
    r.style.setProperty('--tx-fs4', 'calc(1.275rem + 0.3vw)')
    r.style.setProperty('--tx-fs5', '1.25rem')
    r.style.setProperty('--tx-fs6', '1rem')
    r.style.setProperty('--tx-fs7', '0.8rem')
}

function EnlargeFont()
{
    var r = document.querySelector(':root')
    var rs = getComputedStyle(r)
    if (rs.getPropertyValue('--tx-fs1') === 'calc(1.375rem + 1.5vw)')
    {
        r.style.setProperty('--tx-fs1', 'calc(1.4rem + 2.0vw)')
        r.style.setProperty('--tx-fs2', 'calc(1.375rem + 1.5vw)')
        r.style.setProperty('--tx-fs3', 'calc(1.325rem + 0.9vw)')
        r.style.setProperty('--tx-fs4', 'calc(1.3rem + 0.6vw)')
        r.style.setProperty('--tx-fs5', 'calc(1.275rem + 0.3vw)')
        r.style.setProperty('--tx-fs6', '1.25rem')
        r.style.setProperty('--tx-fs7', '1rem')
    }
}

function Logout()
{
    localStorage.setItem("matriculaFuncionario", undefined)
    localStorage.setItem("nomeFuncionario", undefined)
    localStorage.setItem("permissoesFuncionario", undefined)
    localStorage.setItem("cargoFuncionario", undefined)
    localStorage.setItem("token", undefined)
    localStorage.setItem("tokenType", undefined)
    window.location.href="/"
}

function PrefeituraInfo()
{
    return(
        <Stack direction="horizontal">
            <img src={logoPrefeitura} width="20%" height="20%" alt="logo" />
            <p className="fw-bold">PREFEITURA<br/>DE ARACAJU</p>
        </Stack>
    )
}

function LinkLogin()
{
    return (
        <Link className="btn btn-primary fs-6 rounded-3" to={Links.ENTRAR}>
            <Image src={imageMinhaConta} />
            Entrar
        </Link>
    )
}

function DropDownMenu({image, text, options})
{
    return (
        <Dropdown>
            <Dropdown.Toggle className="d-flex flex-column align-items-center" variant="primary" id="dropdown-basic">
                <Image src={image} />
                {text}
            </Dropdown.Toggle>

            <Dropdown.Menu className="btn-primary" variant="dark">
                {
                    options.map((option) => 
                    {
                        return(
                            <Dropdown.Item key={option.key} className="text-white" onClick={option.onClick}>{option.text}</Dropdown.Item>
                        )
                    })
                }
            </Dropdown.Menu>
        </Dropdown>
    )
}

function DropDownMinhaConta()
{
    const navigate = useNavigate()
    const RedirectToMinhaConta = () => { navigate(Links.MINHA_CONTA, {state:{tabID: 0}}) }
    const RedirectToMeusProcessos = () => { navigate(Links.MEUS_PROCESSOS) }
    const RedirectToMinhasMultas = () => { navigate(Links.MINHAS_MULTAS) }
    const options =
    [
        {
            key: "minha-conta",
            onClick: RedirectToMinhaConta,
            text: "Dados da conta"
        },
        {
            key: "meus-processos",
            onClick: RedirectToMeusProcessos,
            text: "Meus processos"
        },
        {
            key: "minhas-multas",
            onClick: RedirectToMinhasMultas,
            text: "Minhas multas"
        },
        {
            key: "sair-conta",
            onClick: Logout,
            text: "Sair da conta"
        }
    ]

    return (<DropDownMenu image={imageMinhaConta} text={"Minha conta"} options={options}/>)
}

function DropDownGestao()
{
    const navigate = useNavigate()
    const RedirectToGerenciarPermissoes = () => { navigate(Links.GERENCIAR_PERMISSOES) }
    const RedirectToLevantamentos = () => { navigate(Links.LEVANTAMENTOS) }
    const RedirectToCadastrarUsuario = () => { navigate(Links.CADASTRAR_USUARIO) }
    const RedirectToAlterarSenhaUsuario = () => { navigate(Links.ALTERAR_SENHA_USUARIO) }
    const RedirectToVerFuncionarios = () => { navigate(Links.VER_FUNCIONARIOS) }
    let options = []

    if(userHasAccess(ROLE.GESTOR))
    {
        options.push({key: "cadastrar-usuario", onClick: RedirectToCadastrarUsuario, text: "Cadastrar usuário"})
        options.push({key: "gerenciar-permissoes", onClick: RedirectToGerenciarPermissoes, text: "Gerenciar Permissões"})
        options.push({key: "alterar-senha-usuario", onClick: RedirectToAlterarSenhaUsuario, text: "Alterar senha do usuário"})
        options.push({key: "funcionarios", onClick: RedirectToVerFuncionarios, text: "Funcionários"})
        options.push({key: "levantamentos", onClick: RedirectToLevantamentos, text: "Levantamentos"})
    }

    return(
            options.length > 0 ? 
            <DropDownMenu image={imageMinhaConta} text={"Gestão"} options={options}/> 
            : 
            <></>
    )
}

function Botoes({ logado })
{
    return (
        <Stack direction="horizontal" className="justify-content-end" gap={3}>
            <Link className="btn btn-primary fs-6 rounded-3" to="/">
                <Image src={headerHome} />
                Home
            </Link>

            <div className="btn btn-primary container rounded-3">
                <div className="row">
                    <div className="col">
                        <Image src={headerAcessColors} onClick={SwitchColors} />
                    </div>
                    <div className="col">
                        <p className="fs-6 my-0" onClick={ShortenFont}>A-</p>
                    </div>
                    <div className="col">
                        <p className="fs-6 my-0" onClick={DefaultFont}>A</p>
                    </div>
                    <div className="col">
                        <p className="fs-6 my-0" onClick={EnlargeFont}>A+</p>
                    </div>
                </div>
                <div className="row">
                    <p className="fs-6 my-0">Acessibilidade</p>
                </div>
            </div>
            { logado ? DropDownMinhaConta() : LinkLogin() }
            { logado ? DropDownGestao() : <></>}
        </Stack>
    )
}

export default function Header()
{
    return (
        <header>
            <Container className="bg-light text-dark my-2">
                <Row>
                    <Col>
                        <PrefeituraInfo />
                    </Col>
                    <Col className="d-flex justify-content-center">
                        <Botoes logado={userLogado} />
                    </Col>
                </Row>
            </Container>
        </header>
    )
}